'use strict';

var loginTypes = {
    USERNAME_PASSWORD: 'USERNAME_PASSWORD',
    PLATFORM_OTP: 'PLATFORM_OTP'
};

module.exports = loginTypes;